import Reflux from 'reflux'

export default Reflux.createActions([
	'setCategory',
	'setText',
	'reset'
])



// WEBPACK FOOTER //
// ./src/actions/filters.js